import './App.css';
import { Layout, Menu, Row, Col, List, Popover, Tag, Typography, Divider, Select } from 'antd';
import SearchForm from './SearchForm';
import vaccineData from './data';
import { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import Banner from './Banner';
import ModalList from './ModalList';
import StatsStrip from './StatsStrip'; 
const { Title } = Typography;
const { Header, Content, Footer } = Layout;
const { Option, OptGroup } = Select;


function HomePage() {
  const [centerData, setCenterData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setisModalVisible] = useState(false);
  const [city, setCity] = useState(null); 

  const fecthData = (districtID=265) =>{
    const today = moment().format('DD-MM-YYYY');
    const URL = `https://cdn-api.co-vin.in/api/v2/appointment/sessions/public/calendarByDistrict?district_id=${districtID}&date=${today}`

    setLoading(true);
    axios.get(URL)
      .then(function (response) {
        setCenterData(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }
  useEffect(() => {
    fecthData(); 
  }, []);


const fetchAvalDetails = (cityID) =>{
  setisModalVisible(true)
  fecthData(cityID)
}

function handleChange(value) {
  // console.log(`selected district ${value}`);
  fecthData(value);
}



  return (
    <Layout className="layout"> 

      <Content>

      <Banner setisModalVisible={setisModalVisible} fetchAvalDetails={fetchAvalDetails} setCityModal={setCity} loadingModal={loading} />

        <div className={''}> 
        <div className={'wrapper'}> 
          <Row justify={'center'}>
          <Col lg={8} className={'px-4'}>

{/* <iframe className="airtable-embed" src="https://airtable.com/embed/shrTWvDF0UwtojCbc?backgroundColor=cyan" frameBorder={0} onmousewheel width="100%" height={700} style={{"background":"transparent","border":"1px solid #ccc"}} /> */}

<div className={'p-4 mt-10'}>
<p className={'mt-8 text-center text-grey-1'}>Can't find your City? Reach out to us in the chatbox on this page and we'll add it right away.</p> 
<p className={' text-center text-grey-1'}>Not Affiliated with Cowin in any way. For all queries, please write to <a target="_blank" href="mailto:support@vaccine-notifier.in">support@vaccine-notifier.in</a>.<br/></p>
<p className={' text-center text-grey-1'}>Take care and stay safe!</p> 
</div>

</Col> 
      
          </Row>


        </div>
        </div>
             <ModalList city={city} setisModalVisible={setisModalVisible} isModalVisible={isModalVisible} centerData={centerData} /> 
      </Content>
 
      
      <StatsStrip />
      
      <Footer style={{ textAlign: 'center' }}>
        <p className="author-info m-0">Developed with ❤ by <a target="_blank" href="https://vishnubaliga.com/">Vishnu Baliga</a> &amp; <a target="_blank" href="https://twitter.com/Bharathsnvs">Bharath</a> </p>
        <p className="freepik-info mt-4"><a target="_blank" href='https://www.freepik.com/vectors/doctor'>Doctor vector created by pikisuperstar - www.freepik.com</a></p>
      </Footer>
    </Layout>
  );
}

export default HomePage;
